import { SkuDashboard } from '../domain/models/SkuDashboard';
import { SkuDetail, SkuDetailSection, SkuConstraints } from '../domain/models/SkuDetail';
import { SkuRepository } from "../domain/repositories/SkuRepository";
import { axiosApp } from './remote/AxiosFactory';
import { handleRemoteResponse } from './remote/hanldeRemoteResponse';
import { Sku } from '../domain/models/Sku';
import { handleAxiosResult } from './remote/handleAxiosResult';
import { DashboardSkuGroup } from '../domain/models/DashboardSkuGroup';
import { SkuModalSection } from '../domain/constants/SkuModalSection';
import { SkuWebComponent } from '../domain/constants/SkuWebComponent';

export class SkuDataRepository implements SkuRepository {

    async getDashboard(): Promise<DashboardSkuGroup[]> {
        const response = await handleAxiosResult(axiosApp().get(`/carrier/dashboard?`));
        return handleRemoteResponse(response, (r: any) => {
            return r.map((group: any) => {
                return new DashboardSkuGroup({
                    ...group,
                    skus: group.skus.map((sku: any) => {
                        return new Sku({ ...sku });
                    }),
                    shortcuts: group.shortcuts.map((sku: any) => {
                        return new Sku({ ...sku });
                    })
                })
            });
        });
    }
    async getAllSkus(): Promise<SkuDashboard> {
        const response = await handleAxiosResult(axiosApp().get(`/carrier/groups?`));
        return handleRemoteResponse(response, (r: any) => {
            return new SkuDashboard({
                tiempoAire: r["Tiempo Aire"]?.map((e: any) => {
                    return new Sku({ ...e });
                }) ?? [],
                paquetes: r["Paquetes"]?.map((e: any) => {
                    return new Sku({ ...e });
                }) ?? [],
                peajes: r["Peajes"]?.map((e: any) => {
                    return new Sku({ ...e });
                }) ?? [],
                pines: r["Pines de entretenimiento"]?.map((e: any) => {
                    return new Sku({ ...e });
                }) ?? [],
                servicios: r["Servicios"]?.map((e: any) => {
                    return new Sku({ ...e });
                }) ?? []
            });

        });
    }
    async getSkuDetail(sku: string): Promise<SkuDetail> {
        if (sku === 'ACCESOD_ACTIVACION') {
            // Para ACCESOD_ACTIVACION, primero mostrar el formulario QR
            // No llamar inmediatamente a /activaciones/params hasta tener la ref
            return new SkuDetail({
                response: [
                    new SkuDetailSection({
                        modal_section: SkuModalSection.Body,
                        web_component: SkuWebComponent.InputQR,
                        web_label: ' ',
                        web_value: '',
                        param: 'ref',
                        send_to_server: true,
                        ordinal: 0,
                        constraints: new SkuConstraints({})
                    })
                ]
            } as any);
        }

        const result = await handleAxiosResult(axiosApp().get(`/topup/request/params?sku=${sku}`));
        return handleRemoteResponse(result, (r: any) => {
            return new SkuDetail({
                response: r.map((section: any) => {
                    return new SkuDetailSection({
                        ...section,
                        constraints: new SkuConstraints({
                            ...section.constraints
                        })
                    });
                })
            });
        });
    }

    async getSkuDetailAfterActivation(sku: string, token: string, ref: string): Promise<SkuDetail> {
        const result = await handleAxiosResult(
            axiosApp(false).get(`/activaciones/params?token=${token}&ref=${ref}`)
        );
        return handleRemoteResponse(result, (r: any) => {
            const params = r.data?.params || r.params || r;
            const meta = r.data?.meta || r.meta;
            
            const sections: SkuDetailSection[] = [];

            if (meta) {
                sections.push(new SkuDetailSection({
                    modal_section: SkuModalSection.Body,
                    web_component: SkuWebComponent.ActivationInfo,
                    web_label: 'Información de Activación',
                    web_value: meta,
                    param: 'activation_meta',
                    send_to_server: false,
                    ordinal: 0,
                    constraints: new SkuConstraints({})
                }));
            }

            params.forEach((param: any, index: number) => {
                sections.push(new SkuDetailSection({
                    modal_section: SkuModalSection.Body,
                    web_component: this.getWebComponentFromParam(param),
                    web_label: param.web_label || param.param,
                    web_value: param.web_value || '',
                    param: param.param,
                    send_to_server: param.param !== 'message-info',
                    ordinal: index + 1,
                    constraints: new SkuConstraints({})
                }));
            });
            
            return new SkuDetail({
                response: sections as any
            });
        });
    }

    private getWebComponentFromParam(param: any): string {
        switch (param.param) {
            case 'destination':
                return SkuWebComponent.InputTextWithConfirmation;
            case 'message-info':
                return SkuWebComponent.MessageInfo;
            case 'sku':
            case 'messageType':
            case 'requestFrom':
                return SkuWebComponent.InputHidden;
            default:
                return SkuWebComponent.InputTextWithConfirmation;
        }
    }
}